// HelloPage.jsx
import React from "react";
import TechnologyRDPage from "./TechnologyRDPage";
import ClinicalValidationPage from "./cclinicalValidationPage";
import IPRegulatoryPathwayPage from "./pathway";
import FludeePage from "./FludeePage";
import FludeeProductPage from "./Fludeeproduct";
import BreadcrumbNav from "./BreadcrumbNav";

export default function Addpages() {
  return (
    <>
    {/* <BreadcrumbNav/> */}
       <FludeePage/> 
       <FludeeProductPage />  
       <TechnologyRDPage />
       <ClinicalValidationPage />  
       <IPRegulatoryPathwayPage />
    </>
  );
}
